import { Switch } from '@components/ui/Primitives'
import React, { useState } from 'react'
import styled from 'styled-components'

interface Props {
  value: boolean
  onToggle: (accountId: number, newValue: boolean) => Promise<any>
  row: any
  disabled?: boolean
}

export const EditableToggle: React.FC<Props> = ({
  value,
  row: { original },
  onToggle,
  disabled = false
}) => {
  const [isLoading, setLoading] = useState(false)

  const handleToggle = () => {
    setLoading(true)
    return onToggle(original.id, !value).finally(() => setLoading(false))
  }

  const handleKeyUp = e => {
    if (e.key === 'Enter') {
      handleToggle()
    }
  }

  return (
    <SwitchWrapper>
      <Switch
        checked={value}
        disabled={isLoading || disabled}
        onChange={handleToggle}
        onKeyUp={handleKeyUp}
      />
    </SwitchWrapper>
  )
}

const SwitchWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.sm}rem ${({ theme }) => theme.spacing.sm}rem;
  height: 18px;
  display: flex;
  align-items: center;
`
